export default {
  path: '/certificados-de-calibracao/:id',
  component: () => import('@/components/pages/CalibrationCertificates/CalibrationCertificate')
}
